import useRestricByPlanType from "@customHooks/restricted-routes/use-restrict-by-plan-type"
import { PlanModule } from "@interfaces/permission_access"

interface RequirePlanModuleProps
{
    module: PlanModule,
    children: JSX.Element
}

/**
 * Renders the route only when the current plan includes `module`.
 * Otherwise `useRestricByPlanType` notifies the user and redirects to the private profile.
 */
const RequirePlanModule = (props: RequirePlanModuleProps) => {
    const { data } = useRestricByPlanType(props.module)
    return data ? props.children : null
}

export default RequirePlanModule
